import { render, staticRenderFns } from "./JiXuJiaoYu.vue?vue&type=template&id=1f713abd&scoped=true&"
import script from "./JiXuJiaoYu.vue?vue&type=script&lang=js&"
export * from "./JiXuJiaoYu.vue?vue&type=script&lang=js&"
import style0 from "./JiXuJiaoYu.vue?vue&type=style&index=0&id=1f713abd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f713abd",
  null
  
)

export default component.exports